import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@learningblocks/exp-constants/lib/Images/ps_powerbutton_icon.svg';
import { Image } from '@learningblocks/shared-components/lib/Image';
import { Button } from '@learningblocks/shared-components/lib/Button';
import { useTranslation } from 'react-i18next';

import './style.scss';

const TRANSLATION_KEY = {
  EnablePowerSupply: 'EnablePowerSupply.string',
  DisablePowerSupply: 'DisablePowerSupply.string'
};

export function PowerButton(props) {
  const {
    t,
    //i18n
  } = useTranslation();

  const className = props.disabled
    ? 'ps_powerButton-disabled'
    : 'ps_powerButton';

  return (
    <div className={props.className}>
      <Button className={className} onClick={props.onClick}>
        <Image src={Icon} alt={props.disabled
          ? t(TRANSLATION_KEY.DisablePowerSupply)
          : t(TRANSLATION_KEY.EnablePowerSupply)} />
      </Button>
    </div>
  );
}

PowerButton.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * callback function to trigger on click
   */
  onClick: PropTypes.func,
};

PowerButton.defaultProps = {
  disabled: false,
};
